"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var number_precision_1 = __importDefault(require("number-precision"));
var constants_1 = require("@hobt/constants");
var utils_1 = require("@hobt/utils");
number_precision_1.default.enableBoundaryChecking(false);
exports.validateDecimal = function (sch, data) {
    var beforeDecimal = Number(sch[0] - sch[1]);
    var afterDecimal = Number(sch[1]);
    var parts = Math.abs(Number(data));
    var absPart = parts.toString().split('.');
    if (absPart[1] != null && absPart[1].length > afterDecimal) {
        return {
            precisionError: true,
            afterDecimal: afterDecimal,
            isValidDecimal: false,
        };
    }
    return {
        isValidDecimal: absPart[0].length <= beforeDecimal &&
            (absPart.length < 2 || absPart[1].length <= afterDecimal),
    };
};
exports.validDecimal = function (sch, data, _parentSchema, dataPath) {
    if (dataPath == null || typeof dataPath !== 'string') {
        return false;
    }
    var _a = exports.validateDecimal(sch, data), precisionError = _a.precisionError, afterDecimal = _a.afterDecimal, isValidDecimal = _a.isValidDecimal;
    if (precisionError === true) {
        exports.validDecimal.errors = [
            {
                keyword: 'decimal',
                message: "must have no more than " + afterDecimal + " digits of precision",
                params: { keyword: 'decimal' },
                dataPath: dataPath,
                schemaPath: '',
            },
        ];
    }
    return isValidDecimal;
};
// TODO: Possibly remove this function as we now have formatMinimum and formatMaximum functions
exports.validateStriclyPastDate = function (_sch, data, _parentSchema, dataPath) {
    if (dataPath == null || typeof dataPath !== 'string') {
        return false;
    }
    exports.validateStriclyPastDate.errors = [
        {
            keyword: 'errorMessage',
            message: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_STRICTLY_PAST_DATE, "" + dataPath.replace(/\//g, '.').replace(/^\./, '')),
            params: { keyword: 'strictlyPastDate' },
            dataPath: dataPath,
            schemaPath: '',
        },
    ];
    return moment_timezone_1.default(data, 'YYYY-MM-DD')
        .tz('America/Toronto')
        .isBefore(utils_1.getCurrentDate());
};
// TODO: Possibly remove this function as we now have formatMinimum and formatMaximum functions
exports.validateNotFutureDate = function (_sch, data, _parentSchema, dataPath) {
    if (dataPath == null || typeof dataPath !== 'string') {
        return false;
    }
    exports.validateNotFutureDate.errors = [
        {
            keyword: 'errorMessage',
            message: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_CANNOT_BE_FUTURE_DATE, "" + dataPath.replace(/\//g, '.').replace(/^\./, '')),
            params: { keyword: 'notAFutureDate' },
            dataPath: dataPath,
            schemaPath: '',
        },
    ];
    return moment_timezone_1.default(data, 'YYYY-MM-DD')
        .tz('America/Toronto')
        .isBefore(moment_timezone_1.default()
        .add(1, 'days')
        .tz('America/Toronto')
        .format('YYYY-MM-DD'));
};
exports.validPostalCode = function (provinceCode, postalCode, _parentSchema, dataPath) {
    if (dataPath == null || typeof dataPath !== 'string') {
        return false;
    }
    var message = constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_PROPERTY_POSTAL_CODE_PROVINCE_MISMATCH);
    exports.validPostalCode.errors = [
        {
            keyword: 'errorMessage',
            message: message,
            params: { keyword: 'isValidPostalCode' },
            dataPath: dataPath,
            schemaPath: '',
        },
    ];
    if (provinceCode == null || !Object.values(constants_1.StatisticsCanadaProvinceID).includes(provinceCode)) {
        return false;
    }
    return utils_1.validatePostalCode(provinceCode, postalCode);
};
// Only used to validate that First Listing Expiry Date must be at least 90 days after Listing date
exports.isAtLeast90Days = function (sch, date, _parentSchema, dataPath) {
    if (dataPath == null || typeof dataPath !== 'string') {
        return false;
    }
    exports.isAtLeast90Days.errors = [
        {
            keyword: 'errorMessage',
            message: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_LISTING_5),
            params: { keyword: 'isAtLeast90Days' },
            dataPath: dataPath,
            schemaPath: '',
        },
    ];
    return moment_timezone_1.default(date, 'YYYY-MM-DD')
        .tz('America/Toronto')
        .isAfter(moment_timezone_1.default(sch, 'YYYY-MM-DD')
        .tz('America/Toronto')
        .add(90, 'days')
        .format('YYYY-MM-DD'));
};
exports.isExclusivelyBeforeCurrentDay = function (_sch, date, _parentSchema, dataPath) {
    if (dataPath == null || typeof dataPath !== 'string') {
        return false;
    }
    var currentDate = utils_1.getCurrentDate();
    exports.isExclusivelyBeforeCurrentDay.errors = [
        {
            keyword: 'errorMessage',
            message: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_STRICTLY_PAST_DATE, "" + dataPath.replace(/\//g, '.').replace(/^\./, '')),
            params: { keyword: 'isExclusivelyBeforeCurrentDay' },
            dataPath: dataPath,
            schemaPath: '',
        },
    ];
    return moment_timezone_1.default(date, 'YYYY-MM-DD')
        .tz('America/Toronto')
        .isSameOrBefore(moment_timezone_1.default(currentDate, 'YYYY-MM-DD')
        .tz('America/Toronto')
        .format('YYYY-MM-DD'));
};
exports.isAfterFirstListingDate = function (sch, listings, _parentSchema, dataPath) {
    if (dataPath == null || typeof dataPath !== 'string') {
        return false;
    }
    if (!Array.isArray(sch) || sch.length < 1) {
        return false;
    }
    if (!Array.isArray(listings) || listings.length < 2) {
        return true;
    }
    var errors = [];
    var results = sch.map(function (date) {
        if (date == null || typeof date !== 'string') {
            return false;
        }
        var firstListingDate = listings[0][date];
        var secondListingDate = listings[1][date];
        if (firstListingDate == null || secondListingDate == null) {
            return true;
        }
        var isAfter = moment_timezone_1.default(secondListingDate, 'YYYY-MM-DD')
            .tz('America/Toronto')
            .isAfter(moment_timezone_1.default(firstListingDate, 'YYYY-MM-DD').tz('America/Toronto'));
        if (isAfter === false) {
            errors.push({
                keyword: 'errorMessage',
                message: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_LISTING_2, date),
                params: { keyword: 'isAfterFirstListingDate' },
                dataPath: dataPath + "/1/" + date,
                schemaPath: '',
            });
        }
        return isAfter;
    });
    exports.isAfterFirstListingDate.errors = errors;
    return results.every(function (value) { return value === true; });
};
exports.isYukonOrBritishColumbiaScenario = function (provinceCode, data, _parentSchema, dataPath) {
    if (dataPath == null || typeof dataPath !== 'string') {
        return false;
    }
    var errors = [];
    var claimTypeCode = data.claimTypeCode, receivedDeficiencySaleClosingDate = data.receivedDeficiencySaleClosingDate;
    if (claimTypeCode === '03' && receivedDeficiencySaleClosingDate == null) {
        if (provinceCode === constants_1.StatisticsCanadaProvinceID.BritishColumbia ||
            provinceCode === constants_1.StatisticsCanadaProvinceID.Yukon) {
            return true;
        }
        errors.push({
            keyword: 'required',
            message: "should have required property 'receivedDeficiencySaleClosingDate'",
            params: { keyword: 'isYukonOrBritishColumbiaScenario' },
            dataPath: dataPath + "/receivedDeficiencySaleClosingDate",
            schemaPath: '#/required',
        });
    }
    if (errors.length > 0) {
        exports.isYukonOrBritishColumbiaScenario.errors = errors;
        return false;
    }
    return true;
};
exports.isAfterClaimReceivedDate = function (claimReceivedDate, items, _parentSchema, dataPath) {
    if (dataPath == null || typeof dataPath !== 'string') {
        return false;
    }
    if (!Array.isArray(items) || items.length < 0) {
        return true;
    }
    var errors = [];
    items.forEach(function (element, index) {
        var receivedDate = element.receivedDate;
        var isFutureDate = moment_timezone_1.default(receivedDate, 'YYYY-MM-DD')
            .tz('America/Toronto')
            .isAfter(utils_1.getCurrentDate());
        var isAfterReceivedDate = moment_timezone_1.default(receivedDate, 'YYYY-MM-DD')
            .tz('America/Toronto')
            .isAfter(moment_timezone_1.default(claimReceivedDate, 'YYYY-MM-DD').tz('America/Toronto'));
        if (isFutureDate === true) {
            errors.push({
                keyword: 'errorMessage',
                message: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_STRICTLY_PAST_DATE),
                params: { keyword: 'isAfterClaimReceivedDate' },
                dataPath: dataPath + "/" + index + "/receivedDate",
                schemaPath: '',
            });
        }
        if (isAfterReceivedDate === true) {
            errors.push({
                keyword: 'errorMessage',
                message: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DATE_PRIOR_CLAIM_SUBMISSION_DATE),
                params: { keyword: 'isAfterClaimReceivedDate' },
                dataPath: dataPath + "/" + index + "/receivedDate",
                schemaPath: '',
            });
        }
    });
    if (errors.length > 0) {
        exports.isAfterClaimReceivedDate.errors = errors;
        return false;
    }
    return true;
};
exports.hasValidOtherAdjustmentCounts = function (_sch, otherAdjustments, _parentSchema, dataPath) {
    if (dataPath == null || typeof dataPath !== 'string') {
        return false;
    }
    if (!Array.isArray(otherAdjustments)) {
        return false;
    }
    var errors = [];
    var maxTwoAdjustmentCodes = [
        constants_1.OtherAdjustmentCode.LateFiling,
        constants_1.OtherAdjustmentCode.LegalActionDelayFee,
    ];
    var maxThreeAdjustmentCodes = [constants_1.OtherAdjustmentCode.OtherAdjustment2];
    var occurrences = {};
    otherAdjustments.forEach(function (otherAdjustment) {
        var currentCode = otherAdjustment.code;
        occurrences[currentCode] = occurrences[currentCode] ? occurrences[currentCode] + 1 : 1;
    });
    Object.entries(occurrences).forEach(function (_a, index) {
        var key = _a[0], value = _a[1];
        var currentCode = key;
        var occurrence = value;
        if ((maxTwoAdjustmentCodes.includes(currentCode) && occurrence > 2) ||
            (maxThreeAdjustmentCodes.includes(currentCode) && occurrence > 3) ||
            (!maxTwoAdjustmentCodes.includes(currentCode) &&
                !maxThreeAdjustmentCodes.includes(currentCode) &&
                occurrence > 1)) {
            errors.push({
                keyword: 'errorMessage',
                message: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_ADJUSTMENT_CODE_MAX_OCCURRENCE),
                params: { keyword: 'hasValidOtherAdjustmentCounts' },
                dataPath: dataPath + "/" + index + "/code",
                schemaPath: '',
            });
        }
    });
    if (errors.length > 0) {
        exports.hasValidOtherAdjustmentCounts.errors = errors;
        return false;
    }
    return true;
};
exports.isLessThanFirstListingAmount = function (sch, listings, _parentSchema, dataPath) {
    if (dataPath == null || typeof dataPath !== 'string') {
        return false;
    }
    if (!Array.isArray(sch) || sch.length < 1) {
        return false;
    }
    if (!Array.isArray(listings) || listings.length < 2) {
        return true;
    }
    var errors = [];
    var results = sch.map(function (amount) {
        if (amount == null || typeof amount !== 'string') {
            return false;
        }
        var firstListingAmount = listings[0][amount];
        var secondListingAmount = listings[1][amount];
        if (firstListingAmount == null || secondListingAmount == null) {
            return true;
        }
        var isLessThan = secondListingAmount < firstListingAmount;
        if (!isLessThan) {
            errors.push({
                keyword: 'errorMessage',
                message: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_LISTING_1, amount),
                params: { keyword: 'isLessThanFirstListingAmount' },
                dataPath: dataPath + "/1/" + amount,
                schemaPath: '',
            });
        }
        return isLessThan;
    });
    exports.isLessThanFirstListingAmount.errors = errors;
    return results.every(function (value) { return value === true; });
};
exports.validateFormatMinimum = function (sch, date, parentSchema, dataPath) {
    var _a;
    if (dataPath == null || typeof dataPath !== 'string') {
        return false;
    }
    var message = dataPath.replace(/\//g, '.').replace(/^\./, '') + " cannot be before " + sch;
    if (((_a = parentSchema === null || parentSchema === void 0 ? void 0 : parentSchema.formatMinimum) === null || _a === void 0 ? void 0 : _a.customErrorMessage) != null) {
        message = parentSchema.formatMinimum.customErrorMessage;
    }
    var comparedDate = sch.const ? sch.const : sch;
    exports.validateFormatMinimum.errors = [
        {
            keyword: 'errorMessage',
            message: message,
            params: { keyword: 'formatMinimum' },
            dataPath: dataPath,
            schemaPath: '',
        },
    ];
    return moment_timezone_1.default(date, 'YYYY-MM-DD')
        .tz('America/Toronto')
        .isSameOrAfter(comparedDate);
};
exports.validateFormatMaximum = function (sch, date, parentSchema, dataPath) {
    var _a;
    if (dataPath == null || typeof dataPath !== 'string') {
        return false;
    }
    var message = dataPath.replace(/\//g, '.').replace(/^\./, '') + " cannot be after " + sch;
    if (((_a = parentSchema === null || parentSchema === void 0 ? void 0 : parentSchema.formatMaximum) === null || _a === void 0 ? void 0 : _a.customErrorMessage) != null) {
        message = parentSchema.formatMaximum.customErrorMessage;
    }
    var comparedDate = sch.const ? sch.const : sch;
    exports.validateFormatMaximum.errors = [
        {
            keyword: 'errorMessage',
            message: message,
            params: { keyword: 'formatMaximum' },
            dataPath: dataPath,
            schemaPath: '',
        },
    ];
    return moment_timezone_1.default(date, 'YYYY-MM-DD')
        .tz('America/Toronto')
        .isSameOrBefore(comparedDate);
};
exports.validateFormatExclusiveMinimum = function (sch, date, parentSchema, dataPath) {
    var _a;
    if (dataPath == null || typeof dataPath !== 'string') {
        return false;
    }
    var message = dataPath
        .replace(/\//g, '.')
        .replace(/^\./, '') + " cannot be equal to or before " + sch;
    if (((_a = parentSchema === null || parentSchema === void 0 ? void 0 : parentSchema.formatExclusiveMinimum) === null || _a === void 0 ? void 0 : _a.customErrorMessage) != null) {
        message = parentSchema.formatExclusiveMinimum.customErrorMessage;
    }
    var comparedDate = sch.const ? sch.const : sch;
    exports.validateFormatExclusiveMinimum.errors = [
        {
            keyword: 'errorMessage',
            message: message,
            params: { keyword: 'formatExclusiveMinimum' },
            dataPath: dataPath,
            schemaPath: '',
        },
    ];
    return moment_timezone_1.default(date, 'YYYY-MM-DD')
        .tz('America/Toronto')
        .isAfter(comparedDate);
};
exports.validateFormatExclusiveMaximum = function (sch, date, parentSchema, dataPath) {
    var _a;
    if (dataPath == null || typeof dataPath !== 'string') {
        return false;
    }
    var message = dataPath
        .replace(/\//g, '.')
        .replace(/^\./, '') + " cannot be equal to or after " + sch;
    if (((_a = parentSchema === null || parentSchema === void 0 ? void 0 : parentSchema.formatExclusiveMaximum) === null || _a === void 0 ? void 0 : _a.customErrorMessage) != null) {
        message = parentSchema.formatExclusiveMaximum.customErrorMessage;
    }
    var comparedDate = sch.const ? sch.const : sch;
    exports.validateFormatExclusiveMaximum.errors = [
        {
            keyword: 'errorMessage',
            message: message,
            params: { keyword: 'formatExclusiveMaximum' },
            dataPath: dataPath,
            schemaPath: '',
        },
    ];
    return moment_timezone_1.default(date, 'YYYY-MM-DD')
        .tz('America/Toronto')
        .isBefore(comparedDate);
};
exports.validatePropertyBedCountUnitCount = function (_sch, data, _parentSchema, dataPath) {
    if (dataPath == null || typeof dataPath !== 'string') {
        return false;
    }
    var bedCount = data.bedCount, unitCount = data.unitCount;
    var message = constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_PROPERTY_BED_UNIT_COUNT);
    exports.validatePropertyBedCountUnitCount.errors = [
        {
            keyword: 'errorMessage',
            message: message,
            params: { keyword: 'isValidPropertyBedCountUnitCount' },
            dataPath: dataPath + "/bedCount",
            schemaPath: '',
        },
        {
            keyword: 'errorMessage',
            message: message,
            params: { keyword: 'isValidPropertyBedCountUnitCount' },
            dataPath: dataPath + "/unitCount",
            schemaPath: '',
        },
    ];
    return ((bedCount != null &&
        bedCount > 0 &&
        ((unitCount != null && unitCount === 0) || unitCount == null)) ||
        (unitCount != null &&
            unitCount > 0 &&
            ((bedCount != null && bedCount === 0) || bedCount == null)));
};
exports.isMultipleOf = function (sch, data, _parentSchema, _dataPath) {
    return Number.isInteger(number_precision_1.default.divide(data, sch));
};
exports.isAfterLastCompleteInstallmentPaidDueDate = function (receivedLastCompleteInstallmentPaidDueDate, items, _parentSchema, dataPath) {
    if (dataPath == null || typeof dataPath !== 'string') {
        return false;
    }
    if (!Array.isArray(items) || items.length === 0) {
        return true;
    }
    var errors = [];
    items.forEach(function (element, index) {
        var code = element.code, receivedDate = element.receivedDate;
        var isBeforeReceivedLastCompleteInstallmentPaidDueDate = moment_timezone_1.default(receivedDate, 'YYYY-MM-DD').isBefore(moment_timezone_1.default(receivedLastCompleteInstallmentPaidDueDate, 'YYYY-MM-DD'));
        if (isBeforeReceivedLastCompleteInstallmentPaidDueDate === true &&
            !['120', '202', '301'].includes(code)) {
            errors.push({
                keyword: 'errorMessage',
                message: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DATE_BORROWER_CHARGE_RECEIVED_DATE),
                params: { keyword: 'isAfterLastCompleteInstallmentPaidDueDate' },
                dataPath: dataPath + "/" + index + "/receivedDate",
                schemaPath: '',
            });
        }
    });
    if (errors.length > 0) {
        exports.isAfterLastCompleteInstallmentPaidDueDate.errors = errors;
        return false;
    }
    return true;
};
